import { environment } from 'environments/environment';

export interface AutoRefreshTarget {
  onAutoRefresh(): void;
}

const interval = environment.AUTORELOADINTERVAL * 1000;

export class AutoRefresh {
  readonly #target: AutoRefreshTarget;
  readonly #invoke: () => void;
  #invervalId: null | number;

  get enabled() {
    return this.#invervalId != null;
  }

  set enabled(value) {
    value = Boolean(value);
    const enabled = this.#invervalId != null;
    if (enabled !== value) {
      if (enabled) {
        window.clearInterval(this.#invervalId);
        this.#invervalId = null;
      } else {
        this.#invervalId = window.setInterval(this.#invoke, interval);
      }
    }
  }

  constructor(target: AutoRefreshTarget) {
    this.#target = target;
    this.#invoke = () => this.#target.onAutoRefresh();
    this.#invervalId = null;
  }

  start(inter = interval) {
    this.#invervalId && window.clearInterval(this.#invervalId);
    this.#invervalId = window.setInterval(this.#invoke, inter);
  }

  stop() {
    if (this.#invervalId) {
      window.clearInterval(this.#invervalId);
      this.#invervalId = null;
    }
  }
}

export default AutoRefresh;
